Object.defineProperty(exports, "__esModule", { value: true });
var FilterNotNull = /** @class */ (function () {
    function FilterNotNull() {
    }
    /**
     * Returns a new sequence consisting of all non-null elements.
     *
     * @returns {Sequence<T>}
     */
    FilterNotNull.prototype.filterNotNull = function () {
        return this.filter(function (it) { return it !== null; });
    };
    return FilterNotNull;
}());
exports.FilterNotNull = FilterNotNull;
//# sourceMappingURL=filterNotNull.js.map